import { put, select, takeLatest } from 'redux-saga/effects';
import requestWrapper from 'utils/requestWrapper';
import history from 'utils/history';
import {
  LOAD_SIGNUPPARENT,
  CHANGE_SIGNUPPARENT,
  DELETE_SIGNUPPARENT,
} from './constants';

import {
  loadSignupParentError,
  loadSignupParentSuccess,
  changeSignupParentError,
  changeSignupParentSuccess,
  deleteSignupParentSuccess,
  deleteSignupParentError,
} from './actions';

import { selectSignupParentDomain, selectSignupParentData } from './selectors';

import { Button, notification, Divider, Space } from 'antd';

export function* loadSignupParent() {
  try {
    // we retrieve the token from the local storage
    const token = localStorage.getItem('token');

    // we get the campaigns linked to the signupParent
    const signupParentList = yield requestWrapper(
      'GET',
      `signupParent/`,
      '',
      token,
    );

    if (!signupParentList) {
      yield put(loadSignupParentSuccess(false));
    } else {
      yield put(loadSignupParentSuccess(signupParentList));
    }
  } catch (error) {
    yield put(loadSignupParentError(error));
  }
}

export function* changeSignupParent(action) {
  try {
    // we retrieve the token from the local storage
    const token = localStorage.getItem('token');
    //const signupParentData = yield select(selectSignupParentData());
    const { signupParentData } = action;

    let changedSignupParent = false,
      isNew = !signupParentData.hasOwnProperty('_id');

    if (signupParentData._id === undefined) {
      changedSignupParent = yield requestWrapper(
        'POST',
        'signupParent/new/',
        signupParentData,
      );
      notification.success({ message: 'Created' });
    } else {
      changedSignupParent = yield requestWrapper(
        'PATCH',
        'signupParent/',
        signupParentData,
      );
      notification.success({ message: 'Updated' });
    }

    if (!changedSignupParent) {
      yield put(changeSignupParentSuccess(false));
    } else {
      // if new we update the url, item props will be updated
      if (isNew) {
        //history.push({ pathname: `/signupParent/`+signupParentData._id });
      }
      yield put(changeSignupParentSuccess(changedSignupParent));
    }
  } catch (error) {
    yield put(changeSignupParentError(error));
  }
}

export function* deleteSignupParent(action) {
  try {
    // we retrieve the token from the local storage
    const token = localStorage.getItem('token');
    const { id } = action;

    const deleteSignupParent = yield requestWrapper(
      'PATCH',
      `signupParent/remove`,
      {
        _id: id,
        active: false,
      },
      token,
    );

    if (deleteSignupParent) {
      yield put(deleteSignupParentSuccess());
    }
  } catch (error) {
    yield put(deleteSignupParentError(error));
  }
}

export default function* signupParentSaga() {
  yield takeLatest(LOAD_SIGNUPPARENT, loadSignupParent);
  yield takeLatest(CHANGE_SIGNUPPARENT, changeSignupParent);
  yield takeLatest(DELETE_SIGNUPPARENT, deleteSignupParent);
}
